<template>
    <div class="settings">
        <div class="setttings__box">
            <TitleCommon value="settings" />
            <Nav :step="step" @on-change-step="onChangeStep" />
            <ResetPin v-if="step === 1" />
            <Print v-else-if="step === 2" />
            <Version v-else />
        </div>
    </div>
</template>
<script>
import TitleCommon from '@/components/common/title'
import Nav from '@/components/settings/nav.vue'
import ResetPin from '@/components/settings/reset-pin.vue'
import Print from '@/components/settings/print.vue'
import Version from '@/components/settings/version.vue'

export default {
    components: { TitleCommon, Nav, ResetPin, Print, Version },
    data() {
        return {
            step: 1,
        }
    },
    methods: {
        onChangeStep(step) {
            this.step = step
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/settings/_index.scss';
</style>
